import React, { useRef } from "react";
import { FaInstagram } from "react-icons/fa";
import { IoMdMenu, IoMdClose } from "react-icons/io";
import { FiTwitter } from "react-icons/fi";
import { AiOutlineLinkedin } from "react-icons/ai";
import { useNavigate } from "react-router-dom";
import {scroller, } from 'react-scroll'

import logo from "../assets/logo1.png";

function Navbar() {

  const navDialogRef = useRef(null);
  const navigate = useNavigate();

  const handleMenu = () => {
    if (navDialogRef.current) {
      navDialogRef.current.classList.toggle("hidden");
    }


  };

  const handleScroll = (id) => {
   navigate("/")
    setTimeout(() => {
      scroller.scrollTo(id, {
        duration: 5000,
        delay: 0,
        smooth: "easeInOutQuart",
      });
      if (navDialogRef.current) {
        navDialogRef.current.classList.add("hidden");
      }
    }, 100);
  };

  return (
    <div className="w-full bg-black opacity-100">
      <nav className="p-3 w-[90%] m-auto flex bg-black opacity-100 justify-between items-center text-white">
        <a href="" className="flex gap-2 items-center">
          <img
            height={50}
            width={50}
            src={logo}
            className="object-cover max-w-12"
            alt="ByteSafe Logo"
          />
          <span className="text-lg font-medium" >ByteSafe</span>
        </a>

        <div id="nav-menu" className="hidden lg:flex gap-12">
          <a onClick={() => handleScroll("home")} className="font-medium hover:text-blue-700">
            HOME
          </a>
          <a onClick={() => handleScroll("services")} className="font-medium hover:text-blue-700">
            SERVICES
          </a>
          <a href="https://bytesafe.in/blogs/" className="font-medium hover:text-blue-700">
            BLOGS
          </a>
          <a  onClick={() => handleScroll("about")} className="font-medium hover:text-blue-700">
            ABOUT
          </a>
          <a onClick={() => handleScroll("contact")} className="font-medium hover:text-blue-700">
            CONTACT US
          </a>
        </div>

        <div className="hidden lg:flex gap-2 items-center">
          <a>
            <AiOutlineLinkedin size={25} />
          </a>
          <a>
            <FiTwitter size={25} />
          </a>
          <a>
            <FaInstagram size={25} />
          </a>
        </div>

        <button className="p-2 lg:hidden" onClick={handleMenu}>
          <IoMdMenu size={30} />
        </button>

        <div
          id="nav-dialog"
          ref={navDialogRef}
          className="hidden fixed z-10 lg:hidden bg-black inset-0 p-3 w-full"
        >
          <div className="w-[90%] m-auto">
            <div id="nav-bar" className="flex justify-between">
              <a href="#" id="brand" className="flex gap-2 items-center">
                <img
                  src={logo}
                  className="object-cover max-w-12"
                  alt="ByteSafe Logo"
                />
                <span className="text-lg font-medium">ByteSafe</span>
              </a>
              <button className="p-2 lg:hidden" onClick={handleMenu}>
                <IoMdClose size={30} color="text-blue-500" />
              </button>
            </div>
            <div className="mt-6">
              <a
                onClick={() => handleScroll("home")}
                className="font-medium m-3 p-3 hover:bg-gray-100 block rounded"
              >
                HOME
              </a>
              <a
                onClick={() => handleScroll("services")}
                className="font-medium m-3 p-3 hover:bg-gray-100 block rounded"
              >
                SERVICES
              </a>
              <a
                href="https://www.bytesafe.in/blogs/"
                className="font-medium m-3 p-3 hover:bg-gray-100 block rounded"
              >
                BLOGS
              </a>
              <a
                onClick={() => handleScroll("about")}
                className="font-medium m-3 p-3 hover:bg-gray-100 block rounded"
              >
                ABOUT US
              </a>
              <a
                onClick={() => handleScroll("contact")}
                className="font-medium m-3 p-3 hover:bg-gray-100 block rounded"
              >
                CONTACT US
              </a>
            </div>
            <div className="h-[2px] w-full bg-gray-100"></div>
            <div className="mt-6 ml-6 w-full flex gap-2 items-center">
              <a >
                <AiOutlineLinkedin size={25} src="https://www.linkedin.com/company/bytesafe-technologies/" />
              </a>
              <a>
                <FiTwitter size={25} src="https://x.com/bytesafe1" />
              </a>
              <a>
                <FaInstagram size={25} src="https://www.instagram.com/bytesafetechnologies/" />
              </a>
            </div>
          </div>
        </div>
      </nav>
    </div>
  );
}

export default Navbar;
